import { EPaymentMethodType } from '../../types/redux/paymentMethods';

const DELIMITER = '|';

interface IPaymentId {
  index: number;
  type: EPaymentMethodType;
}

export const encodePaymentMethodId = (params: IPaymentId): string => {
  const { index, type } = params;

  return [index, type].join(DELIMITER);
};

export const decodePaymentMethodId = (id: string): IPaymentId => {
  const [index, type] = id.split(DELIMITER);

  return {
    index: Number(index),
    type: type as EPaymentMethodType,
  };
};
